import { DropdownButtonOption } from "./type";

export const filterOutHiddenOptions = (option: DropdownButtonOption): boolean =>
  !(option.isHidden === true);
